import * as React from 'react';

import {
  Colors,
  Breakpoint,

  useDimensions,
} from '@bluecurrent/web-component-lib';

export default function Image() {
  const size = useDimensions();

  return (
    <>
      <div
        style={{
          height: '100%',
          width: '50%',
          position: 'absolute',
          zIndex: 2,
          background: `linear-gradient(90deg, ${Colors.GRADIENT} 0%, ${Colors.GRADIENT}00 100%)`,
          bottom: 0,
        }}
      />
      <div
        style={{
          height: 700,
          width: 700,
          position: 'absolute',
          zIndex: 3,
          backgroundImage: 'url("https://cdn.sanity.io/images/pnajo2cq/production/5e71a7306837bd89b43e13a7c9f9ede8e95bf59a-1000x1000.png")',
          backgroundPosition: 'no-repeat',
          backgroundSize: 'cover',
          bottom: -100,
          right: size.width < Breakpoint.sm ? -250 : -100,
        }}
      />
    </>
  );
}
